import VeeValidate from 'vee-validate';
import AlertifyPlugin from './alertify';
import ToastrPlugin from './toasts';

export default [ToastrPlugin, AlertifyPlugin, VeeValidate];
